import { useState, useEffect } from "react";
import "./style.css";

const services = [
  "Registration",
  "Company Registration",
  "Private Limited Company",
  "Limited Liability Partnership (LLP)",
  "One Person Company",
  "Section 8 Company (Non Profit Organization)",
  "Public Limited Company",
  "Gst Registration",
  "Professional Tax Registration (P-Tax)",
  "Pan & Tan Registration",
  "Udyam / MSME Registration",
  "Startup India Registration",
  "Import Export Code",
  "Tax & Compliances",
  "Direct Tax",
  "Income Tax Filing",
  "Individual",
  "LLP",
  "Company",
  "AOP",
  "BOI",
  "TDS & TCS Filing",
  "Tax Audit (Form 3CA / 3CB / 3CD)",
  "Statutory Audit",
  "Pan Correction and Reissue",
  "Assessment & Representation",
  "Advance Tax and Self Assessment Tax",
  "Capital Gains & Investment Advisory",
  "Indirect Tax",
  "Gst Registrations & Services",
  "GST Return Filing (GSTR 1, 3B, 4, 9/9C)",
  "GST Audit & Certification",
  "GST Refund & Export Related Services",
  "GST Advisory & Planning Tax",
  "Input Tax Credit Management",
  "Representation & Litigation Support",
  "E-invoicing & E-way bill Compliance",
  "Trademark & Certifications",
  "Trademark Applications & Filing",
  "TradeMark Search And Advisory",
  "Trademark Renewal",
  "Income / Net worth Certificates",
  "Turn over or Profit Certificates",
  "Statutory Certificates",
  "Provisional/Projected Financial Certificate (Project Report)",
  "Working Capital Certificate",
  "Stock / BookDebt Certificate",
  "Fund Flow Certificate",
  "MCA Services",
  "Company Incorporation and Registration",
  "Private Limited Company Registration",
  "One Person Company Registration (OPC)",
  "Limited Liability Partnership Registration",
  "Section 8 Company (Non Profit Organization)",
  "Public Limited Company",
  "Post Incorporation Compliances (INC-20A, ADT-1, etc)",
  "Conversion of Entity Type (LLP to Pvt ltd, etc)",
  "Annual ROC Filings & Compliances",
  "AOC-4 / AOC-4 XBRL - Filing of Financial Statements",
  "MGT-7 / MGT-7A - Annual Return Filing",
  "ADT-1 - Appointment of Auditor",
  "DIR-3 KYC / DIR-3 KYC Web - Directory KYC",
  "DPT-3 - Return of Deposits / Loans / Advances",
  "MGT-14 - Disclosure of Resolutions",
  "Director & ShareHolder Services",
  "DIN Application / Modification",
  "Director Resignation or Appointment Filings",
  "Change in Designation (DIR-12)",
  "DIR-3 KYC filing & Activation",
  "Share Allotment, transfer, and issuance filings",
  "Maintenance of Statutory registers",
  "Secretarial & Legal Documentation",
  "Drafting of MOA / AOA Amendments",
  "Drafting of Board Resolutions",
  "Drafting of Shareholder Meeting Notices & Minutes",
  "Drafting of Directors Reports",
  "Drafting of Share Certificates and Registers",
  "Drafting of Share Transfer Forms (SH-4)",
  "Online CA Services",
  "Accounting Services"
];

export const ContactModal = ({ isOpen, onClose, selectedService = "" }) => {
  const [formData, setFormData] = useState({
    fullName: "",
    phoneNumber: "",
    email: "",
    service: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      // Set the selected service when modal opens
      if (selectedService) {
        setFormData(prev => ({ ...prev, service: selectedService }));
      }
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, selectedService]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ type: '', message: '' });

    try {
      const response = await fetch('https://ca-services-pcyc.onrender.com/api/contacts', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          source: 'contact_modal'
        })
      });

      const data = await response.json();

      if (data.success) {
        setSubmitStatus({ 
          type: 'success', 
          message: '✅ Thank you! Your details have been submitted successfully. We will contact you shortly.' 
        });
        
        // Reset form after 2 seconds
        setTimeout(() => {
          setFormData({
            fullName: "",
            phoneNumber: "",
            email: "",
            service: ""
          });
          setSubmitStatus({ type: '', message: '' });
          onClose();
        }, 2000);
      } else {
        setSubmitStatus({ 
          type: 'error', 
          message: '❌ ' + (data.message || 'Failed to submit. Please try again.') 
        });
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus({ 
        type: 'error', 
        message: '❌ Network error. Please make sure the backend server is running.' 
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        
        <h2 className="modal-title">
          Enter your details to receive a full quote<br />
          and consultation
        </h2>

        <form className="contact-form" onSubmit={handleSubmit}>
          {submitStatus.message && (
            <div className={`submit-status ${submitStatus.type}`}>
              {submitStatus.message}
            </div>
          )}

          <div className="form-group">
            <input
              type="text"
              name="fullName"
              placeholder="Full Name"
              className="form-input"
              value={formData.fullName}
              onChange={handleChange}
              required
              disabled={isSubmitting}
            />
            <span className="required-asterisk">*</span>
          </div>

          <div className="form-group">
            <input
              type="tel"
              name="phoneNumber"
              placeholder="Phone Number"
              className="form-input"
              value={formData.phoneNumber}
              onChange={handleChange}
              required
              disabled={isSubmitting}
            />
            <span className="required-asterisk">*</span>
          </div>

          <div className="form-group">
            <input
              type="email"
              name="email"
              placeholder="Enter Your Email (Optional)"
              className="form-input"
              value={formData.email}
              onChange={handleChange}
              disabled={isSubmitting}
            />
          </div>

          <div className="form-group">
            <select
              name="service"
              className="form-input form-select"
              value={formData.service}
              onChange={handleChange}
              required
              disabled={isSubmitting}
            >
              <option value="" disabled>Select Services You are Looking for</option>
              {services.map((service, index) => (
                <option key={index} value={service}>
                  {service}
                </option>
              ))}
            </select>
            <span className="required-asterisk">*</span>
          </div>

          <button type="submit" className="submit-button" disabled={isSubmitting}>
            {isSubmitting ? 'Submitting...' : 'Claim Your Free Consultation'}
          </button>
        </form>
      </div>
    </div>
  );
};

